<template>
    <section>
        <v-container class="nav">
            <v-btn
                icon
                class="black--text"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiFileDocument }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Consultation Approval
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- End App Bar -->
        <v-container style="width:90%; margin:auto">
            <h2> Automated Out-Patient Consultation Request Terms of Service</h2>
            <div v-if="getEligibility && getEligibility.eligible == true">
                <p>
                    You can now request an approval instantly for out-patient consultations with HMI Affliated Doctors, Clinics, and Hospitals.
                    Please note that this feature is for <b>FACE-TO-FACE CONSULTATION ONLY</b>. Your request may be denied if the system has found that your account has any of, but not limited to, the following reasons:
                    <br><br>
                    <ul>
                        <li>Your account has expired, has lapsed, in or is cancelled.</li>
                        <li>You have outstanding bills to pay with HMI.</li>
                        <li>You have exceeded your maximum benefit limit within the contract term.</li>
                    </ul>
                    <br>
                    Moreover, note that your online consultation requests are automatically added to your utilization records. If you have any concerns, please contact HMI.
                </p>
                <h1>Quick Instructions</h1>
                <p>
                    <ol>
                        <li>Click the "Request For Approval" button below.</li>
                        <li>Check if your information in our system is correct as shown on the first section of the form.</li>
                        <li>Fill out the information about the healthcare provider, hospital, clinic, and/or doctor whom you wish to have an appointment for a face-to-face consultation.</li>
                        <li>If the appointment is a referral from another HMI-affliated healthcare provider, hospital, clinic, and/or doctor, tick the checkbox and fill out the correct information.</li>
                        <li>Click submit and wait for the results of the automated adjudication on your request.</li>
                        <li>If your request is approved, check your email (the one you registered on HMI Portal) for your approval slip. You may also download the slip by clicking "Download" on the results page or by going to the History page. If your request is denied, please call HMI.</li>
                    </ol>
                </p>
                <div style="background-color: white; padding: 3px; border-radius: 5px;">
                    <v-alert
                        color="teal darken-4"
                        outlined
                        style="margin: 0;"
                        type="info"
                    >
                        <span><strong>Disclaimer: </strong>The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.</span>
                    </v-alert>
                </div>
                <p>
                    <v-checkbox
                        v-model="read_terms"
                        label="I have read and understood the Terms of Service and Instructions."
                    />
                </p>
            </div>
            <div v-else>
                <p> Your account cannot access this service at this moment. Please contact HMI for more information.</p>
            </div>
        </v-container>
        <!-- End Instructions -->
        <div v-if="getEligibility.eligible == true">
            <v-container class="requestWrapper">
                <v-btn :disabled="!read_terms" class="teal white--text" @click="$router.push(`/dashboard/consultation/request/`)">
                    <h1>Request for Approval</h1>
                </v-btn>
            </v-container>
        </div>
    </section>
</template>

<script>
import { mdiArrowLeft, mdiFileDocument } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => {
        return({
            mdiArrowLeft, mdiFileDocument,
            read_terms: false
        })
    },
    computed: {
        ...mapGetters(['getEligibility'])
    },
    async created() {
        this.isEligibleForOP({ MEMBN: this.$cookies.get('usermembn') })
    },
    methods: {
        ...mapActions(['getCsrfToken', 'isEligibleForOP'])
    }
}
</script>

<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

h1 {
    font-size: 18px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
